/**
 * Service: donationsApi
 */
angular.module('acme.common.service.donationsApi', [
  'acme.common.factory.apiVersion',
  'acme.common.factory.QueryStringBuilder'
])
.service('DonationsApiService', [
  '$http', '$timeout', '$q', 'ApiVersionFactory', 'QueryStringBuilderFactory',
  function($http, $timeout, $q, ApiVersionFactory, QueryStringBuilderFactory) {

    return {

      service: '',

      init: function(endpoint) {
        this.service = endpoint + '/donation';
        this.configs.service = this.service + '/configs';
        this.customFields.service = this.service + '/customfields';
        return true;
      },

      theme: function () {
        return $http({
          method: 'get',
          url: "/assets/data/donate.json"
        });
      },

      list: function(type, props) {
        var q = '',
            av = new ApiVersionFactory();

        if(props) {
          var qs = new QueryStringBuilderFactory({
            props: props,
            fields: {
              optional: ['sortDirection', 'sortField', 'pageSize', 'page', 'search']
            }
          });
          q = qs.query;
        }
        return $http({
          method: 'get',
          url: av.init({url: (this.service + '/' + type + q), version: 'v2'})
        });
      },

      create: function(type, props) {
        var av = new ApiVersionFactory();
        
        return $http({
          method: 'post',
          url: av.init({url: (this.service + '/' + type), version: 'v2'}),
          data: {
            name: props.name,
            description: props.description,
            isDefault: props.isDefault,
            online: props.online,
            csr: props.csr,
            pos: props.pos,
            insideSalesIndividual: props.insideSalesIndividual
          }
        });
      },

      update: function(type, props) {
        var av = new ApiVersionFactory();

        return $http({
          method: 'put',
          url: av.init({url: (this.service + '/' + type), version: 'v2'}),
          data: {
            id: props.id,
            name: props.name,
            description: props.description,
            isDefault: props.isDefault,
            online: props.online,
            csr: props.csr,
            pos: props.pos,
            insideSalesIndividual: props.insideSalesIndividual
          }
        });
      },

      remove: function(type, id) {
        var av = new ApiVersionFactory();

        return $http({
          method: 'delete',
          url: av.init({url: (this.service + '/' + type + '/' + id), version: 'v2'})
        });
      },

      configs: {

        service: '',

        list: function(props) {
          var q = '',
              av = new ApiVersionFactory();

          if(props) {
            var qs = new QueryStringBuilderFactory({
              props: props,
              fields: {
                optional: ['sortDirection', 'sortField', 'pageSize', 'page', 'search']
              }
            });
            q = qs.query;
          }

          return $http({
            method: 'get',
            url: av.init({url: (this.service + q), version: 'v2'})
          });
        },

        create: function(props) {
          var av = new ApiVersionFactory();

          return $http({
            method: 'post',
            url: av.init({url: this.service, version: 'v2'}),
            data: {
              aspect: props.aspect,
              description: props.description,
              online: props.online,
              csr: props.csr,
              pos: props.pos
            }
          });
        },

        update: function(props) {
          var av = new ApiVersionFactory();

          return $http({
            method: 'put',
            url: av.init({url: this.service, version: 'v2'}),
            data: {
              id: props.id,
              aspect: props.aspect,
              description: props.description,
              online: props.online,
              csr: props.csr,
              pos: props.pos
            }
          });
        },

        remove: function(id) {
          var av = new ApiVersionFactory();

          return $http({
            method: 'delete',
            url: av.init({url: (this.service + '/' + id), version: 'v2'})
          });
        }

      },

      customFields: {
        service: '',

        list: function(props) {
          var av = new ApiVersionFactory(),
          q = '';

          if(props) {
            var qs = new QueryStringBuilderFactory({
              props: props,
              fields: {
                optional: ['sortDirection', 'sortField', 'pageSize', 'page', 'search']
              }
            });
            q = qs.query;
          }

          return $http({
            method: 'get',
            url: av.init({url: (this.service + q), version: 'v2'})
          });
        },

        create: function(props) {
          var av = new ApiVersionFactory();

          return $http({
            method: 'post',
            url: av.init({url: this.service, version: 'v2'}),
            data: props
          });
        },

        update: function(props) {
          var av = new ApiVersionFactory();

          return $http({
            method: 'put',
            url: av.init({url: this.service, version: 'v2'}),
            data: props
          });
        },

        remove: function(id) {
          return $http({
            method: 'delete',
            url: av.init({url: (this.service + '/' + id), version: 'v2'})
          });
        }

      }
    };
}]);
